import ErrorBoundary from './ErrorBoundary';

export function WrappedErrorBoundary(Component: React.ComponentType<any>) {
  return function WrappedWithErrorBoundary(props: any) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
}
